import { useMemo } from 'react'
import { useVenue } from '@/hooks/useVenue'
import { useWidgetSettings } from '@/hooks/useWidgetSettings'
import { useTheme } from '@sevenrooms/ui-kit'
import { generateGX } from '@sevenrooms/ui-kit/theme'
import type { OtherVenueInfo } from '@/domain'

export function useOtherVenueTheme(otherVenue?: OtherVenueInfo) {
  const theme = useTheme()
  const { venueColor } = useVenue()
  const { colorPrimary } = useWidgetSettings()
  const selectedBrandColor = otherVenue?.colorPrimary ?? colorPrimary
  const selectedVenueColor = otherVenue?.venueColor ?? venueColor
  return useMemo(
    () =>
      generateGX({
        ...theme,
        colors: {
          ...theme.colors,
          brandColor: selectedBrandColor,
          venueColor: selectedVenueColor,
        },
      }),
    [theme, selectedBrandColor, selectedVenueColor]
  )
}
